// src/components/ScrollRestoration.js
import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

export default function ScrollRestoration() {
  const { pathname } = useLocation();
  const navigationType = useNavigationType(); // "PUSH", "POP", or "REPLACE"

  // Save scroll before navigating away
  useEffect(() => {
    const handleBeforeUnload = () => {
      sessionStorage.setItem("scroll-back", window.scrollY.toString());
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      // also save on unmount
      sessionStorage.setItem("scroll-back", window.scrollY.toString());
    };
  }, []);

  // Restore on navigation
  useEffect(() => {
    if (navigationType === "PUSH") {
      window.scrollTo(0, 0);
    } else if (navigationType === "POP") {
      const saved = sessionStorage.getItem("scroll-back");
      if (saved) {
        window.scrollTo(0, parseInt(saved, 10));
      }
    }
  }, [pathname, navigationType]);

  return null;
}
